import { BulkDialogProps } from "../helpers/DialogBulk/hooks";
import {
  DialogAPIErrorParam,
  DialogConfirmParam,
  DialogInProgressParam,
  DialogLocalErrorParam,
  DialogSuccessParam,
} from "../helpers/hooks";

// 被参照情報の読み込みを管理する型
export type ReferredFromState = "waiting" | "including" | "notIncluding";

export const dialogActionNames = {
  delete: "削除",
  remove: "完全削除",
  duplicate: "複製",
  recovery: "復元",
  enable: "有効化",
  disable: "無効化",
  redeploy: "再デプロイ",
  updateCategory: "カテゴリー変更",
  updateRole: "ロール更新",
  cancel: "キャンセル",
  invite: "招待",
  cancelInvitation: "招待取り消し",
  reinvite: "再招待",
  rejectInvitation: "招待拒否",
  acceptInvitation: "招待承諾",
};

export const dialogTargetNames = {
  view: "ビュー",
  sheet: "シート",
  version: "バージョン",
  versionCategory: "カテゴリー",
  organization: "組織",
  member: "メンバー",
  role: "ロール",
  connectMaster: "Connectマスタ",
  endpointAddonMaster: "Endpoint Addonマスタ",
  endpointAddon: "Endpoint Addon",
  permissionMaster: "Permissionマスタ",
  ciMaster: "CIマスタ",
  connect: "Connect",
  viewMaster: "ビューマスタ",
  frontendAddon: "フロントエンドアドオン",
  algorithmVersion: "アルゴリズムバージョン",
  tadSheet: "時間累積データシート",
};

export const getDialogMessages = ({
  isSome,
  actionType,
  targetType,
  targetName,
  withName,
}: {
  isSome: boolean;
  actionType: keyof typeof dialogActionNames;
  targetType: keyof typeof dialogTargetNames;
  targetName?: string;
  withName?: boolean;
}) => {
  const baseTarget = dialogTargetNames[targetType];
  const action = dialogActionNames[actionType];
  const prefix = isSome ? "選択" : "";

  const messages: {
    inProgress: Pick<DialogInProgressParam, "title">;
    confirm: Pick<
      DialogConfirmParam,
      "displayMessage" | "title" | "buttonText"
    > &
      Pick<
        BulkDialogProps<string, Record<string, string>>,
        "startButtonText" | "operationName"
      >;
    success: Pick<DialogSuccessParam, "displayMessage">;
    error:
      | Pick<DialogAPIErrorParam, "displayMessage">
      | Pick<DialogLocalErrorParam, "displayMessage">;
  } = {
    confirm: {
      title: prefix + `${baseTarget}の${action}`,
      displayMessage: withName
        ? `${isSome ? "選択した" : ""}${targetName ?? baseTarget}を${action}します。新しい${baseTarget}の名前を入力してください。`
        : `${isSome ? "選択した" : ""}${targetName ?? baseTarget}を${action}しますか？`,
      buttonText: action,
      startButtonText: action + "開始",
      operationName: prefix + `${baseTarget}の${action}`,
    },
    inProgress: {
      title: prefix + `${baseTarget}を${action}しています`,
    },
    success: {
      displayMessage: prefix + `${baseTarget}の${action}に成功しました`,
    },
    error: {
      displayMessage: prefix + `${baseTarget}の${action}に失敗しました`,
    },
  };
  return messages;
};
